"use client";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import OffcanvasArea from "@/components/sidebar/offcanvas/offcanvas-area";

type Props = {
  children?: React.ReactNode;
  offcanvas_cls?: string;
  transparent?: boolean;
  headerTwo?: boolean;
};

export default function OffcanvasButton({
  transparent,
  offcanvas_cls = "",
  headerTwo = false,
}: Props) {
  const [isOpenOffcanvas, setIsOpenOffcanvas] = useState(false);
  const [mounted, setMounted] = useState(false);
  const modalRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      modalRef.current = document.getElementById("offcanvas-sidebar");
      setMounted(true);
    }
  }, []);

  const handleOffcanvasToggle = () => {
    setIsOpenOffcanvas((open) => !open);
  };

  return (
    <>
      <button
        onClick={handleOffcanvasToggle}
        className={`${transparent ? "" : "offcanvas-menu"} offcanvas-open-btn`}
        aria-label="Close navigation menu"
        aria-expanded={isOpenOffcanvas}
        type="button"
      >
        <i className="fa-solid fa-bars" aria-hidden="true" />
        <span className="sr-only">Close navigation menu</span>
      </button>

      {mounted &&
        modalRef.current &&
        createPortal(
          <OffcanvasArea
            openOffCanvas={isOpenOffcanvas}
            onHandleOffCanvas={handleOffcanvasToggle}
            offcanvas_cls={offcanvas_cls}
            headerTwo={headerTwo}
          />,
          modalRef.current
        )}
    </>
  );
}
